import { createVNode as s, mergeProps as n } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MessageManageFilledStandard.js";
import d from "../components/PfIcon.js";
const e = (a, r) => {
  const t = {
    ...a,
    ...r.attrs
  };
  return s(d, n(t, {
    icon: o
  }), null);
};
e.displayName = "MessageManageFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
